// eslint-disable-next-line @typescript-eslint/naming-convention
export const ModalSizes = {
  full: 'full',
  sm: 'sm',
  md: 'md',
  lg: 'lg'
} as const

// eslint-disable-next-line no-redeclare
export type ModalSizes = typeof ModalSizes[keyof typeof ModalSizes]
